import dayjs from 'dayjs';
import { Divider } from 'src/components/atoms';
import { useGetMessagesByReportQuery } from 'src/graphql';
import { useTheme } from 'styled-components';
import { DateFormats, isBefore } from 'src/utils/time';
import {
  MessageAuthor,
  MessageBody,
  MessageDetails,
  MessageDetailsContainer,
  MessageItem,
  MessagesListContainer,
} from './MessagesSummaryList.styles';

interface MessagesSummaryListProps {
  selectedMessageIds: string[];
  reportId: string;
}

export const MessagesSummaryList = ({
  selectedMessageIds,
  reportId,
}: MessagesSummaryListProps) => {
  const theme = useTheme();
  const { data: messages } = useGetMessagesByReportQuery({
    report: reportId,
  });

  const messagesToDisplay =
    messages?.getMessagesByReport
      ?.filter((message) => selectedMessageIds.includes(message.id))
      .sort((a, b) => {
        if (isBefore(a.createdAt, b.createdAt)) {
          return -1;
        }

        return 1;
      }) ?? [];

  return (
    <MessagesListContainer>
      {messagesToDisplay.map((message) => (
        <MessageItem key={message.id} data-testid={`message-${message.id}`}>
          <MessageDetailsContainer>
            <MessageAuthor data-testid={`message-author-${message.id}`}>
              {message.author}
            </MessageAuthor>
            <Divider
              variant="vertical"
              color={theme.atlas.semantic.color.outline.default}
              height="10px"
            />
            <MessageDetails data-testid={`message-time-${message.id}`}>
              {dayjs.utc(message.createdAt).format('HH:mm')}
            </MessageDetails>
            <Divider
              variant="vertical"
              color={theme.atlas.semantic.color.outline.default}
              height="10px"
            />
            <MessageDetails data-testid={`message-date-${message.id}`}>
              {dayjs.utc(message.createdAt).format(DateFormats.DAY_MONTH_YEAR)}
            </MessageDetails>
          </MessageDetailsContainer>
          <MessageBody data-testid={`message-body-${message.id}`}>
            {message.value}
          </MessageBody>
        </MessageItem>
      ))}
    </MessagesListContainer>
  );
};
